import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ott-overview-area" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center align-items-center" }
const _hoisted_4 = {
  class: "col-lg-6 col-md-6",
  "data-aos": "fade-up",
  "data-aos-duration": "1000",
  "data-aos-delay": "200"
}
const _hoisted_5 = { class: "ott-overview-btn" }
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "ott-overview-inner",
        style: _normalizeStyle({ backgroundImage: `url(${_ctx.bgImage})` })
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[1] || (_cache[1] = _createElementVNode("div", {
            class: "col-lg-6 col-md-6",
            "data-aos": "fade-up",
            "data-aos-duration": "1000",
            "data-aos-delay": "100"
          }, [
            _createElementVNode("div", { class: "ott-overview-content" }, [
              _createElementVNode("h2", { class: "text-white" }, "ابدأ تجربتك المجانية اليوم")
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("a", {
                href: _ctx.getWhatsappLink(),
                target: "_blank",
                class: "btn"
              }, [...(_cache[0] || (_cache[0] = [
                _createElementVNode("span", { class: "border-style" }, "اشترك الآن", -1)
              ]))], 8, _hoisted_6)
            ])
          ])
        ])
      ], 4)
    ])
  ]))
}